import { Injectable, OnInit } from '@angular/core';
import {  Router, ActivatedRoute } from '@angular/router';
import { User } from '../@core/data/model/user';
import { Token } from '../@core/data/model/token';
import {ApiEndpoints} from '../@core/data/rest/ApiEndpoints';
import {ApiUtils} from '../@core/data/rest/ApiUtils';
import { plainToClass } from 'class-transformer';
import { SharedMethods } from '../util/sharedMethods-service';
import {HttpClient} from '@angular/common/http';
import { FenetreService } from '../@core/utils/fenetre-service';
import { AutoLogoutService } from './auto-logout/auto-logout.service';
import { Subject } from 'rxjs';


// const MINUTES_UNITL_AUTO_LOGOUT = 15 ; // in mins
const CHECK_INTERVAL = 15000; // in ms
const STORE_KEY =  'lastAction';


@Injectable()
export class AuthService {

  token: Token;

  isAuthenticating = false;

  redirect = '';

  isLoginPage = false;

  permissionsToRedirect: string[];

  isTenanTDBChange = false;

  credentiales: {
      login: string,
      password: string,
  };

  logoutEvent = new Subject<any>();

  constructor(private router: Router, private route: ActivatedRoute, public apiEndpoints: ApiEndpoints, public http: HttpClient,
    public apiUtils: ApiUtils, private fenetreService: FenetreService,
    // public networkService:NetworkService,
    public sharedMethods: SharedMethods) {

    if (localStorage.getItem('bessalel_token') !== null && this.isTimeout)
    this.token = plainToClass(Token, JSON.parse(localStorage.getItem('bessalel_token')) as object);
    // this.token = JSON.parse(localStorage.getItem('bessalel_token'));

  }


  public checkinterval(): number {

    return CHECK_INTERVAL;
  }
  public storekey(): string {

    return STORE_KEY;
  }

  public getLastAction() {
    // tslint:disable-next-line:radix
    return parseInt(localStorage.getItem(STORE_KEY));
  }

  public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }

  isTimeout(): boolean {
    const now = Date.now();

    let timeleft: number;

    
    // 5 min pour l'auto déconnexion
    timeleft = this.getLastAction() + 5 * 60 * 1000;

    const diff = timeleft - now;
    const timeout = diff < 0;
    return timeout;

  }

  authenticate() {

    this.isAuthenticating = true;

    const cred = {
        login: this.credentiales.login,
        password: this.credentiales.password,
    };

    // this.apiUtils.TENANTDB = this.credentiales.tenant;

    return new Promise<Token>(resolve => {
        this.http.post(this.apiEndpoints.GET_URL_LOGIN, cred,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Token) =>  {

              localStorage.setItem('bessalel_token', JSON.stringify(data));

              if ( this.apiUtils.TENANTDB !== JSON.parse(localStorage.getItem('tenant'))) {
                localStorage.setItem('tenant', JSON.stringify(this.apiUtils.TENANTDB));
                this.isTenanTDBChange = true;
              }
              // on attribut un role par defaut en attendant d'implémenter la fonctionnalité d'attribution des rôles
              // this.token.user.roles = ['ADMIN'];

              this.login();

              resolve(this.token);

            },
            err => {

              // tslint:disable-next-line:no-console
              // console.log(this.apiEndpoints.GET_URL_LOGIN);
              // console.log(err);
              this.isAuthenticating = false;
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);

            });
    });

  }

  login() {

    if (localStorage.getItem('bessalel_token') !== null) {
      this.token = plainToClass(Token, JSON.parse(localStorage.getItem('bessalel_token')) as object);
      this.apiUtils.CURRENT_ACCESS_TOKEN = this.token.value;
    }

    /* if (localStorage.getItem('tenant') !== null) {
      this.apiUtils.TENANTDB = JSON.parse(localStorage.getItem('tenant'));
    } */

    for (let i = 0; i < this.fenetreService.Open.length; i++) {
      // this.fenetreService.Open[i].pupop.close;
      this.fenetreService.Open[i].pupop.postMessage('connexion', this.fenetreService.Open[i].pupop.location.href);
    }

    // chargement des permissions
    /* this.permissionsToRedirect = [];


    for (let i = 0; i < this.token.user.permissions.length; i++) {
      // this.fenetreService.Open[i].pupop.close;
      this.permissionsToRedirect.push(this.token.user.permissions[i].value);
    } */


    // this.router.navigate([this.redirect]);


    if ( this.isHavingPermission(this.permissionsToRedirect) ) {

      /* if (this.isTenanTDBChange) {
        window.location.href = '#' + this.redirect;
        window.location.reload();
      } else {
        this.router.navigate([this.redirect]);
      } */


      window.location.href = '#' + this.redirect;
      this.isLoginPage = false;

      if (this.isTenanTDBChange)
      window.location.reload();

    } else {

      /* if (this.isTenanTDBChange) {
        window.location.href = '#';
        window.location.reload();
      } else {
        this.router.navigate(['']);
      } */
      window.location.href = '#';
      this.isLoginPage = false;

      if (this.isTenanTDBChange)
      window.location.reload();

    }

    // this.isAuthenticating = false;

  }

  logout() {

    // s'il s'agit d'une fenetre popup on la laisse connecter car sera fermé par la fenetre principale
    // Et on oubli pas de supprimer le localStorage de popup à la fin
    /* if (this.fenetreService.findnames(window.name) !== null )
    return; */

    if (this.router.url !== '/pages/login') {
      this.redirect = this.router.url;
      // this.permissionsToRedirect = this.router.routerState.snapshot.root.data.permissions;
    }

    localStorage.removeItem('bessalel_token');
    // localStorage.removeItem('tenant');
    // this.apiUtils.TENANTDB = '';
    this.apiUtils.CURRENT_ACCESS_TOKEN = '';
    this.token = null;

    for (let i = 0; i < this.fenetreService.Open.length; i++) {
      // this.fenetreService.Open[i].pupop.close;
      this.fenetreService.Open[i].pupop.postMessage('deconnexion', this.fenetreService.Open[i].pupop.location.href);
    }

    // localStorage.removeItem('popup');

    // tslint:disable-next-line:no-console
    // console.log(this.permissionsToRedirect);

    this.logoutEvent.next('logout');

    this.router.navigate(['/pages/login']);

  }

  isHavingPermission(permission: string[]): boolean {

    let result = false;

    if (permission === undefined )
    return true;

    // a parti d'ici on est sur que permission est différent de undefined
    if (this.token === undefined || this.token === null )
    return false;

    if (this.token.user.permissions !== undefined && this.token.user.permissions !== null) {

        const permissionValues = [];
        for ( let i = 0; i < this.token.user.permissions.length; i++) {

           permissionValues.push(this.token.user.permissions[i].value);
        }

        for ( let i = 0; i < permission.length; i++) {

            if (permissionValues.indexOf(permission[i])  > -1)
            result = true;
        }

    }

    return result;

  }

  

  



}
